export function sanitizeUrl(url: string): string {
  url = url.replace(/^(https?:\/\/)+/, '');

  if (!/^https?:\/\//i.test(url)) {
    url = 'https://' + url;
  }

  return url;
}
